import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneNumberMaskDirective } from './phonenumber-mask.directive';
import { NoSpaceDirective } from './no-space.directive';

@NgModule({
  declarations: [PhoneNumberMaskDirective, NoSpaceDirective],
  imports: [CommonModule],
  exports: [PhoneNumberMaskDirective, NoSpaceDirective],
})
export class DirectivesModule {}
